import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import '../../buttons/enums.js';
import { isRTL } from '../../../utilities/dom-helpers/index.js';

const renderInteractiveElement = (_a) => {
    var props = __rest(_a, []);
    const styleClass = `style-${props.style}`;
    const sizeClass = `size-${props.size}`;
    const classes = `${props.mainClass} ${props.type || ''} ${props.style ? styleClass : ''} ${props.size ? sizeClass : ''}${props.mobileInverted ? 'mobile-inverted' : ''} ${props.mobileWhite ? 'mobileWhite' : ''} ${props.rtl || isRTL() ? 'rtl' : ''} ${props.disabled ? 'disabled' : ''}`;
    const iconTemplate = props.icon
        ? x `<img loading="lazy" src="${props.icon.src}" alt="${props.icon.alt}">`
        : null;
    const renderIconWithText = () => x `${iconTemplate}<span class="sr-only">${props.text}</span>`;
    return props.isAnchor
        ? x `<a class="${classes}" href="${l(props.href)}" target="${l(props.target)}" aria-label="${l(props.ariaLabel)}">${renderIconWithText()}</a>`
        : x `<button class="${classes}" type="${l(props.type)}" aria-label="${l(props.ariaLabel)}" ?disabled="${props.disabled}">${renderIconWithText()}</button>`;
};

export { renderInteractiveElement };
